import { render, staticRenderFns } from "./AddSteps2.vue?vue&type=template&id=1605395d&scoped=true&"
import script from "./AddSteps2.vue?vue&type=script&lang=js&"
export * from "./AddSteps2.vue?vue&type=script&lang=js&"
import style0 from "./AddSteps2.vue?vue&type=style&index=0&id=1605395d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1605395d",
  null
  
)

export default component.exports